<script setup>
import LayoutHeader from "~/layouts/LayoutHeader.vue";
import LayoutFooter from "~/layouts/LayoutFooter.vue";
import {checkDeviceClientSide, checkDeviceServerSide} from "~/utils/common";
import BrandContent from "~/components/brand/BrandContent.vue";
import ModalDownload from "~/components/ModalDownload.vue";
import ModalSizeCharts from "~/components/ModalSizeCharts.vue";
import DrawerMenu from "~/components/DrawerMenu.vue";
import DrawerCart from "~/components/DrawerCart.vue";
import DrawerCartOrderPreview from "~/components/DrawerCartOrderPreview.vue";
import DrawerCartMobileNumberEdit from "~/components/DrawerCartMobileNumberEdit.vue";
import DrawerCartShipmentEdit from "~/components/DrawerCartShipmentEdit.vue";
import ModalLoadingProgress from "~/components/ModalLoadingProgress.vue";
import DrawerAI from "~/components/DrawerAI.vue";
import DrawerAIMore from "~/components/DrawerAIMore.vue";
import DrawerAIFAQ from "~/components/DrawerAIFAQ.vue";
import DrawerFilter from "~/components/DrawerFilter.vue";

definePageMeta({
  keepalive: true
})

const route = useRoute()
const filter = ref({})
const filterCheckedCount = ref(0)

const handleApply = (e, count) => {
  console.log("filter", e, count)
  filter.value = e
  filterCheckedCount.value = count
}

checkDeviceServerSide()

onMounted(async () => {
  checkDeviceClientSide()
})
</script>

<template>
  <layout-header/>
  <brand-content :filter="filter" :filter-checked-count="filterCheckedCount"/>
  <layout-footer/>

  <modal-download/>
  <modal-size-charts/>
  <drawer-a-i/>
  <drawer-a-i-more/>
  <drawer-a-i-f-a-q/>
  <drawer-menu/>
  <drawer-cart/>
  <drawer-cart-order-preview/>
  <drawer-cart-mobile-number-edit/>
  <drawer-cart-shipment-edit/>
  <modal-loading-progress/>
  <drawer-filter
    :filter-query="{brandId: route.params.id}"
    @apply="handleApply"
  />
</template>

<style scoped lang="scss">

</style>
